@if (!$hidden()) {
    @switch($mode()) {

        @case(ButtonMode.Split) {

            <div class="button-container">

                <button type="button" [class]="$buttonClass()" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()" [disabled]="$disabled()" [title]="$tooltip() ?? ''" (click)="onButtonClick($event)">

                    @if($iconLeft(); as iconLeft) {
                        <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}" *ngIf="iconLeft"></i>
                    }

                    @if($label(); as label) {
                        <span *dynamicView="label"></span>
                    }

                    @if($count(); as count) {
                        <span class="count-value" *ngIf="count">{{count}}</span>
                    }

                    @if($iconRight(); as iconRight) {
                        <i class="fa fa-regular" [ngStyle]="{'color': $iconRightColor()}" [ngClass]="iconRight" *ngIf="iconRight"></i>
                    }

                </button>

                <button type="button" [ngClass]="{'menu-open': $menuOpen()}" (click)="toggleButton($event)" cdkOverlayOrigin #menuTrigger="cdkOverlayOrigin">
                    <i class="fa fa-regular fa-chevron-down"></i>
                </button>

                <ng-template #slugOverlay="cdkConnectedOverlay" cdkConnectedOverlayPush="true" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="menuTrigger" [cdkConnectedOverlayPositions]="$overlayPositions()" [cdkConnectedOverlayOpen]="$menuOpen()" [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayPanelClass]="$effectiveOverlayClass()" [cdkConnectedOverlayBackdropClass]="'button-menu-commands-backdrop'" (backdropClick)="hideMenu()">
                    @for(more of $commands(); track more){

                        @if(!more?.hidden) {
                            <w-button mode="MenuItem" (onClick)="onMenuButtonClick(more)" [disabled]="more?.disabled" [label]="more.label" [iconLeft]="more.iconLeft" [iconRight]="more.iconRight" [iconLeftColor]="more.iconLeftColor" [iconRightColor]="more.iconRightColor" [iconLeftSize]="$iconLeftSize()" [iconRightSize]="$iconRightSize()" [menuItem]="true" [displayStyle]="ButtonDisplayStyle.Secondary" />
                        }
                    }
                </ng-template>
            </div>

        }


        @case(ButtonMode.Select) {

            <div class="button-container">

                @for(command of $commands(); track command){

                    @if(!command.hidden) {

                        <button type="button" [ngClass]="{active: command === $activeCommand()}" [class]="$buttonClass()" [disabled]="command?.disabled" [title]="command?.tooltip ?? ''" [class.has-left-icon]="!!command.iconLeft" [class.has-right-icon]="!!command.iconRight" (click)="onSelectButtonClick(command)">

                            @if(command.iconLeft; as iconLeft) {
                                <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                            }

                            @if(command.label; as label) {
                                <span>{{command?.label}}</span>
                            }

                            @if (command?.count; as count) {
                                <span class="count-value">{{count}}</span>
                            }

                            @if(command?.iconRight; as iconRight) {
                                <i class="fa fa-regular" [ngStyle]="{'color': $iconRightColor()}" [ngClass]="iconRight"></i>
                            }

                        </button>

                    }

                }

            </div>

        }

        @case(ButtonMode.Tab) {

            <div class="button-container" #buttonContainer>

                <div class="button-tabs" #buttonTabs>

                    @for(cmd of $commands(); track cmd){

                        @if(!cmd.hidden) {

                            <button [tabButton]="cmd" type="button" [ngClass]="{active: cmd === $activeCommand()}" [class]="$buttonClass()" [disabled]="cmd?.disabled" [title]="cmd?.tooltip ?? ''" [class.has-left-icon]="!!cmd.iconLeft" [class.has-right-icon]="!!cmd.iconRight" (click)="onSelectButtonClick(cmd)">

                                @if(cmd.iconLeft; as iconLeft) {
                                    <i class="fa fa-regular" [ngClass]="cmd?.iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                                }

                                @if(!!cmd.label; as label) {
                                    <span>{{cmd?.label}}</span>
                                }

                                @if (cmd?.count !== null) {
                                    <span class="count-value">{{cmd.count}}</span>
                                }

                                @if (cmd.iconRight) {
                                    <i class="fa fa-regular" [ngStyle]="{'color': $iconRightColor()}" [ngClass]="cmd?.iconRight"></i>
                                }

                            </button>
                        }


                    }

                    <!-- <ng-container *ngIf="commands?.length"> -->
                    <!-- <w-button mode="Menu" [commands]="commands" iconRight="fa-ellipsis" [iconRightSize]="iconRightSize" displayStyle="Tertiary" /> -->
                    <!-- <w-button mode="MenuItem" [commands]="moreCommands" menuAlignment="Left" displayStyle="Tertiary" /> -->
                    <!-- </ng-container> -->

                </div>

                @if($enableTabOverflow()) {
                    <div class="button-overflow" [ngClass]="{active: $overflowActive()}">
                        <w-button tabOverflowButton mode="Menu" [commands]="$overflowCommands()" iconRight="fa-ellipsis" [iconRightSize]="ButtonIconSize.Large" displayStyle="Tertiary" />
                    </div>
                }

            </div>

        }

        @case(ButtonMode.Menu) {

            <button type="button" [class]="$buttonClass()" [ngClass]="{'menu-open': $menuOpen()}" [title]="$tooltip() ?? ''" [disabled]="$disabled() || $commands()?.length < 1" (click)="toggleButton($event)" cdkOverlayOrigin #menuTrigger="cdkOverlayOrigin" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()">
                @if($iconLeft(); as iconLeft) {
                    <i class="fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count(); as count) {
                    <span class="count-value">{{count}}</span>
                }

                @if($iconRight()?.length > 0 || $iconRight() == null){
                    <i class="fa-regular" [ngStyle]="{'color': $iconRightColor()}" [ngClass]="$iconRight() ?? 'fa-chevron-down'"></i>
                }


            </button>

            @if($commands()?.length > 0) {
                <ng-template #slugOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="menuTrigger" [cdkConnectedOverlayPositions]="$overlayPositions()" [cdkConnectedOverlayOpen]="$menuOpen()" [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayPanelClass]="$effectiveOverlayClass()" [cdkConnectedOverlayBackdropClass]="'button-menu-commands-backdrop'" (backdropClick)="hideMenu()">

                    @for(more of $commands(); track more) {
                        <!-- <w-button mode="MenuItem" (onClick)="menuOpen = false" [command]="more" [menuItem]="true" [displayStyle]="ButtonDisplayStyle.Secondary" *ngIf="!more?.hidden"></w-button> -->
                        <w-button mode="MenuItem" (onClick)="onMenuItemClick(more)" [iconLeft]="more?.iconLeft" [label]="more.label" [disabled]="more?.disabled" [menuItem]="true" [displayStyle]="ButtonDisplayStyle.Secondary" *ngIf="!more?.hidden"></w-button>
                    }

                </ng-template>
            }


        }

        @case(ButtonMode.Dropdown) {

            <button type="button" [class]="$buttonClass()" [ngClass]="{'menu-open': $menuOpen()}" [title]="$tooltip() ?? ''" [disabled]="$disabled()" (click)="toggleButton(null)" cdkOverlayOrigin #menuTrigger="cdkOverlayOrigin" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()">

                @if($iconLeft(); as iconLeft) {
                    <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count() !== null) {
                    <span class="count-value">{{$count()}}</span>
                }

                @if($iconRight()?.length > 0 || $iconRight() == null){
                    <i class="fa-regular" [ngClass]="$iconRight() ?? 'fa-chevron-down'"></i>
                }

            </button>

            @if($commands()?.length > 1) {

                <ng-template #slugOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="menuTrigger" [cdkConnectedOverlayPositions]="$overlayPositions()" [cdkConnectedOverlayOpen]="$menuOpen()" [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayPanelClass]="$effectiveOverlayClass()" [cdkConnectedOverlayBackdropClass]="'button-menu-commands-backdrop'" (backdropClick)="hideMenu()">
                    @for(more of $commands(); track more) {

                        @if(more !== $command()) {
                            <w-button mode="MenuItem" (click)="onSelectMenu(more)" [iconLeft]="more?.iconLeft" [command]="more" [displayStyle]="ButtonDisplayStyle.Secondary" [hidden]="$command() === more || more.hidden" />
                        }

                    }
                </ng-template>

            }

        }

        @case(ButtonMode.Overlay) {

            <button type="button" [class]="$buttonClass()" [ngClass]="{'menu-open': $menuOpen()}" [disabled]="$disabled()" [title]="$tooltip() ?? ''" (click)="$readonly() ? false : toggleButton(null)" cdkOverlayOrigin #menuTrigger="cdkOverlayOrigin" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()" #toggleButtonItem>

                @if($iconLeft(); as iconLeft) {
                    <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count() !== null) {
                    <span class="count-value">{{$count()}}</span>
                }

                @if(!$readonly() && $iconRight()) {
                    <i class="fa-regular fa-chevron-down"></i>
                }

            </button>

            <ng-template #slugOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="menuTrigger" [cdkConnectedOverlayPositions]="$overlayPositions()" [cdkConnectedOverlayOpen]="$menuOpen()" [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayPanelClass]="$effectiveOverlayClass()" [cdkConnectedOverlayBackdropClass]="'button-menu-commands-backdrop'" (backdropClick)="hideMenu()">
                <ng-container *ngTemplateOutlet="$overlayContent(); context: { $implicit: toggleButtonItem }"></ng-container>
            </ng-template>

        }

        @case(ButtonMode.Toggle) {

            <button type="button" [class]="$buttonClass()" [disabled]="$disabled()" [title]="$tooltip() ?? ''" (click)="onToggleClick($event)" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()">

                @if($iconLeft(); as iconLeft) {
                    <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count() !== null) {
                    <span class="count-value">{{$count()}}</span>
                }

                @if($iconRight(); as iconRight) {
                    <i class="fa fa-regular" [ngClass]="iconRight" [ngStyle]="{'color': $iconRightColor()}"></i>
                }

            </button>

        }

        @case(ButtonMode.Link) {

            <a [class]="$buttonClass()" [title]="$tooltip() ?? ''" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()" (click)="onButtonClick($event)" [attr.disabled]="$disabled() ? '' : null">

                @if($iconLeft(); as iconLeft) {
                    <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count() !== null) {
                    <span class="count-value">{{$count()}}</span>
                }

                @if($iconRight(); as iconRight) {
                    <i class="fa fa-regular" [ngClass]="iconRight" [ngStyle]="{'color': $iconRightColor()}"></i>
                }

            </a>
        }

        @default() {

            <button type="button" [class]="$buttonClass()" [disabled]="$disabled()" [title]="$tooltip() ?? ''" (click)="onButtonClick($event)" [class.has-left-icon]="!!$iconLeft()" [class.has-right-icon]="!!$iconRight()">

                @if($loading(); as loading) {
                    <i class="fa-solid fa-spinner-third fa-spin" [ngStyle]="{'--fa-animation-duration': '0.5s'}"></i>
                }

                @if($iconLeft(); as iconLeft) {
                    <i class="fa fa-regular" [ngClass]="iconLeft" [ngStyle]="{'color': $iconLeftColor()}"></i>
                }

                @if($avatar(); as avatar) {
                    <img class="avatar" [src]="avatar | svgAvatar">
                }

                @if($label(); as label) {
                    <span *dynamicView="label"></span>
                }

                @if($count() !== null) {
                    <span class="count-value">{{$count()}}</span>
                }

                @if($iconRight(); as iconRight) {
                    <i class="fa fa-regular" [ngClass]="iconRight" [ngStyle]="{'color': $iconRightColor()}"></i>
                }
            </button>

        }

    }
}